










import { computed, defineComponent } from "@vue/composition-api";
import { ChartConfiguration } from "chart.js";
import FormatMoney from "@/components/FormatMoney";
import StatisticChart from "../StatisticChart.vue";

export default defineComponent({
  name: "RangeChartBlock",
  components: { FormatMoney, StatisticChart },
  props: {
    chartConfig: { type: Object as () => ChartConfiguration, required: true },
  },
  setup(props) {
    const totalEarning = computed<number>(() => {
      return props.chartConfig.data.datasets[0].data.reduce<number>((acc, item) => (acc += item as number), 0);
    });

    return { totalEarning };
  },
});
